import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateContact, contactsQueryKeys } from '@api/contacts';
import type { UpdateContactPayload } from '@api/contacts';

// Toast-free contact update for the order flows (the contacts page uses
// useEditContact, which owns its own success toast).
export function useUpdateContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: UpdateContactPayload }) =>
      updateContact(id, payload),
    onSuccess: (_contact, { id }) => {
      queryClient.invalidateQueries({ queryKey: contactsQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: contactsQueryKeys.detail(id) });
    },
  });
}
